import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';

import { HttpClient, HttpHeaders } from '@angular/common/http';

import { GestockService } from '../../services/gestock.service';
import { IMMOBILIER_ROUTES, RouteInfo } from '../../config/immobilier-routes.config';
import { PAYMENT_ROUTES, ADMIN_PAYMENT_ROUTES } from '../../config/payment-routes.config';


declare const $: any;
declare interface RouteInfoCustom {
  path: string;
  title: string;
  icon: string;

  class: string;
}



const httpOptions = {
  headers: new HttpHeaders(
    {
      'Content-Type': 'application/json',
    }
  )
};

/* ADMIN
export const ROUTES: RouteInfoCustom[] = [
    { path: '/homecpnt/dashboard', title: 'Dashboard',  icon: 'dashboard', class: '' },
    { path: '/homecpnt/agence', title: 'Comparateur',  icon:'content_paste', class: '' },
    { path: '/homecpnt/sousreseau', title: 'Sous-Réseau',  icon:'person', class: '' },
    { path: '/homecpnt/versement', title: 'Versements',  icon:'content_paste', class: '' },
    { path: '/homecpnt/appeldefonds', title: 'Appel De Fonds',  icon:'content_paste', class: '' },
    { path: '/homecpnt/histotransact', title: 'Reporting',  icon:'library_books', class: '' },
    { path: '/homecpnt/partners', title: 'Partenaires',  icon: 'toc', class: '' },
    { path: '/homecpnt/packaging', title: 'Packaging',  icon:'view_column', class: '' },
    { path: '/homecpnt/comptafinances', title: 'Compta-Finances',  icon: 'money', class: '' },
    { path: '/homecpnt/avenants', title: 'Avenants',  icon:'settings', class: '' },
    { path: '/homecpnt/parametrage', title: 'Paramètrage',  icon:'settings', class: '' }
];
*/




import { ImmobilierService } from '../../services/immobilier.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  menuItems: any[];

  tampon = "";
  canOnlyPrepay = false;

  samacaabiyoonwii: any;

  existe = false;
  isAdmin = false;

  constructor(private http: HttpClient, private router: Router, private configServer: GestockService, private immobilierService: ImmobilierService) {

    // Charger les routes depuis sessionStorage ou utiliser les routes immobilières par défaut
    let allRoutes: RouteInfoCustom[] = [];
    const storedRoutes = sessionStorage.getItem("yoonyifiam");

    if (storedRoutes) {
      try {
        allRoutes = JSON.parse(storedRoutes);
      } catch (e) {
        console.error('Erreur lors du parsing des routes:', e);
        allRoutes = PAYMENT_ROUTES;
      }
    } else {
      // Utiliser les routes de paiement par défaut
      allRoutes = PAYMENT_ROUTES;
      sessionStorage.setItem("yoonyifiam", JSON.stringify(PAYMENT_ROUTES));
    }

    // Fix: Ensure Audit is visible for Admins even if session storage is stale
    const profil = sessionStorage.getItem("profil");
    this.isAdmin = (profil === "ADMINISTRATEUR");
    if (this.isAdmin) {
      const hasAdminDb = allRoutes.some(r => r.path.includes('payment-admin-dashboard'));
      if (!hasAdminDb) {
        allRoutes.unshift({ path: '/homecpnt/payment-admin-dashboard', title: 'Tableau de bord Admin', icon: 'dashboard', class: '' });
      }
      const hasAdminRep = allRoutes.some(r => r.path.includes('payment-admin-reporting'));
      if (!hasAdminRep) {
        allRoutes.splice(1, 0, { path: '/homecpnt/payment-admin-reporting', title: 'Reporting Admin', icon: 'history', class: '' });
      }
    }

    if (this.isAdmin || !profil) { // !profil check for dev mode where profil might not be set
      const hasAudit = allRoutes.some(r => r.path.includes('audit'));
      if (!hasAudit) {
        allRoutes.push({ path: '/homecpnt/audit', title: 'Journal d\'Audit', icon: 'history', class: '' });
      }
    }

    // Fix: Ensure API Documentation is visible even if session storage is stale
    const hasApiDocs = allRoutes.some(r => r.path.includes('api-docs'));
    if (!hasApiDocs) {
      allRoutes.push({ path: '/homecpnt/api-docs', title: 'Documentation API', icon: 'description', class: '' });
    }

    this.samacaabiyoonwii = sessionStorage.getItem("samacaabiyoonwii");

    // Vérifier si on doit afficher les notifications de recouvrement
    if (this.canSeeRecouvrement(allRoutes) == true)
      this.startRecouvrementChecker();

    this.menuItems = allRoutes.filter(menuItem => menuItem);
  }

  ngOnInit() {
  }

  canSeeRecouvrement(allRoutes: RouteInfoCustom[]) {
    for (var i = 0; i < allRoutes.length; i++) {
      if (allRoutes[i].title == "Recouvrement" || allRoutes[i].title.toLowerCase().includes("recouvrement"))
        return true;
    }
    return false;
  }


  startRecouvrementChecker() {
    // Exécute immédiatement une première fois
    this.checkRecouvrement();

    // Puis toutes les 10 minutes
    setInterval(() => {
      this.checkRecouvrement();
    }, 5 * 60 * 1000); // 10 minutes en ms
  }

  checkRecouvrement() {
    this.configServer.hasClientARecouvrer(this.samacaabiyoonwii).then(retour => {
      this.existe = retour;
      if (this.existe) {
        console.log("Au moins un recouvrement en attente !");
        // ici tu peux aussi afficher une notification visuelle si besoin
      }
    });
  }



  isMobileMenu() {
    if ($(window).width() > 991) {
      return false;
    }
    return true;
  };


  isOnlyPrepaidAuthorized(compliances) {
    let allOfThem = JSON.parse(compliances);
    this.canOnlyPrepay = false;
    for (var i = 0; i < allOfThem.length; i++) {
      if (allOfThem[i].name == "solde_impaye")
        this.canOnlyPrepay = Number(allOfThem[i].valeur) <= 0;
    }
  }


  disconnect() {
    this.tampon = sessionStorage.getItem("samacaabiyoonwii");

    if (this.tampon) {
      this.immobilierService.logout(this.tampon).subscribe(
        res => {
          console.log("Déconnexion réussie");
          this.finalizeDisconnect();
        },
        err => {
          console.error("Erreur lors de la déconnexion", err);
          this.finalizeDisconnect();
        }
      );
    } else {
      this.finalizeDisconnect();
    }
  }

  finalizeDisconnect() {
    sessionStorage.clear();
    localStorage.clear();
    this.router.navigate(['/']);
  }

  /*
  guennGueew() {
    let logooutData = { samacaabiyoonwii: this.tampon };
    this.remotelogger('https://dkm.hybraine.com/gestion/guenngueew.php', logooutData).subscribe(
      retourPost => {
        this.tampon = "";
      });
  }

  remotelogger(url: string, user: any) {
    return this.http.post(url, user, httpOptions);
  }
  */


}
